/**
 * InvestmentCollectDialog — manual "cobrar" modal for an Investment.
 *
 * iter-169zt · Fase 3b — migrated from centered Dialog to the shared
 * BottomSheet so mobile gets thumb-zone sticky CTAs while desktop keeps
 * the centered modal it always had.
 */
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { BottomSheet } from "../../../components/ui/bottom-sheet";
import { AccountPickerField } from "../../../components/AccountPickerField";

export function InvestmentCollectDialog({
  target,
  onOpenChange,
  amount,
  setAmount,
  account,
  setAccount,
  note,
  setNote,
  currency,
  cashAccounts,
  onSubmit,
  lang,
  t,
}) {
  const isEs = lang === "es";
  const title = (
    <span>
      {isEs ? "Cobrar inversión" : "Collect investment"}
      {target && <span className="text-slate-500 ml-2">— {target.name}</span>}
    </span>
  );
  return (
    <BottomSheet
      open={!!target}
      onOpenChange={onOpenChange}
      testid="investment-collect-dialog"
      size="md"
      title={title}
      description={isEs
        ? "Ingresa el monto realmente recibido. Puede diferir del proyectado si la entidad cobró fees."
        : "Enter the amount actually received. May differ from the projection if the entity took fees."}
      footer={
        <div className="flex items-center justify-end gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)} className="h-11">{t("cancel")}</Button>
          <Button data-testid="collect-form-submit" onClick={onSubmit} className="bg-emerald-600 hover:bg-emerald-700 h-11 px-5 font-semibold">
            {isEs ? "Confirmar cobro" : "Confirm"}
          </Button>
        </div>
      }
    >
      <div className="space-y-3">
        <div>
          <Label>{isEs ? `Monto cobrado (${target?.currency || currency})` : `Amount collected (${target?.currency || currency})`}</Label>
          <Input
            data-testid="collect-form-amount"
            type="number"
            inputMode="decimal"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="h-12 text-base rounded-xl mt-1.5"
          />
        </div>
        <AccountPickerField
          label={isEs ? "Cuenta destino" : "Target account"}
          name="collect-form-account"
          accounts={cashAccounts}
          value={account}
          onChange={setAccount}
          primaryOption={{ label: isEs ? "Cuenta principal" : "Primary account" }}
          isEs={isEs}
          testid="collect-form-account-field"
          className="mt-1.5"
        />
        <div>
          <Label>{isEs ? "Nota (opcional)" : "Note (optional)"}</Label>
          <Input
            data-testid="collect-form-note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder={isEs ? "Ej: la entidad cobró 50 USD de comisión" : "e.g. entity charged 50 USD fee"}
            className="h-12 text-base rounded-xl mt-1.5"
          />
        </div>
      </div>
    </BottomSheet>
  );
}
